import styled from "styled-components";

export const ChannelsIcon = styled.img`
    height: 40px;
    width: 40px;
    margin-right: 16px;
`;
